import auth0Client from "app/auth/Auth";
import Company from "app/domain/Company";
import { handleRoute } from "infrastructure/https";

export const getUrl = ({ corporationId }: { corporationId: string }) =>
  `/companies/v1/corporations/${corporationId}/companies`;

const getCompanies = async () => {
  const corporationId = auth0Client.getCorporationId();
  if (!corporationId) return [];

  const { data } = await handleRoute({
    method: "get",
    path: getUrl({ corporationId }),
  });

  return data.content.map(
    (company) =>
      new Company({
        countryISO2Code: company.countryISO2Code,
        id: company.id,
        name: company.name,
      })
  );
};

export default getCompanies;
